<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" :width="dialogWidth" :scrollable="true">
      <v-card>
        <v-card-title class="headline">{{$t('playerProfileDialog.title')}}</v-card-title>
        <v-card-text>
          <player-profile-content :user="user" :game="game"/>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn class="primary" text @click="close()">
            <v-icon left>mdi-close</v-icon>{{$t('common.close')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import PlayerProfileContent from "@/widgets/PlayerProfileContent"

export default {
  name: "PlayerProfileDialog",
  components: {PlayerProfileContent},
  props: {
    user: {
      type: Object,
      required: true
    },
    game: {
      type: Object,
      required: false
    },
    visible: {
      type: Boolean,
      required: true
    },
    closeAction: {
      type: Function,
      required: true
    }
  },
  data: function() {
    return {
      dialog: false,
    };
  },
  computed: {
    dialogWidth: function() {
      if (this.$vuetify.breakpoint.smAndUp) {
        return "550";
      }
      return "80%";
    }
  },
  watch: {
    visible: function(val) {
      this.dialog = val;
    },
    dialog: function(val) {
      if (val === false) {
        this.closeAction();
      }
    },
    value: function() {
      // console.log("value changed to", val);
    }
  },
  created() {
  },
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    close() {
      this.$emit("input", this.user);
      this.dialog = false;
    },
  }
};
</script>
